import { isEmpty, isString, isFunction, isBoolean, isNumber as isNumberLib, isNaN, isInteger, isDate, isArray } from 'lodash';
export { isFunction, isBoolean, isDate, isInteger };
export function isNonEmptyString(str) {
  return !isEmpty(str) && isString(str);
}
export function isNumber(val) {
  return isNumberLib(val) && !isNaN(val);
}

function isGreaterThanEqual(val, typeCheck, needle) {
  return typeCheck(val) && val >= needle;
}

function isIntegerGreaterThanEqual(val, needle) {
  return isGreaterThanEqual(val, isInteger, needle);
}

export function isPositiveInteger(val) {
  return isIntegerGreaterThanEqual(val, 1);
}
export function isPositiveIntegerOrZero(val) {
  return isIntegerGreaterThanEqual(val, 0);
}
export function isDefinedNotNull(val) {
  return val != null;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function isArrayOf(arr, validator) {
  if (!isArray(arr)) return false;
  return arr.findIndex(function (val) {
    return !validator(val);
  }) === -1;
}